export var CombinedRole;
(function (CombinedRole) {
    CombinedRole["AGENCY"] = "AGENCY";
    CombinedRole["YALEO_SELF_BOOKING_USER"] = "YALEO_SELF_BOOKING_USER";
    CombinedRole["NEW_COMPANY"] = "NEW_COMPANY";
})(CombinedRole || (CombinedRole = {}));
export var StorageKey;
(function (StorageKey) {
    StorageKey["TOKEN"] = "token";
    StorageKey["SELECTED_COMPANY"] = "adnz_selected_company";
    StorageKey["TEMPORARY_ACCESS_EXPIRES_AT"] = "adnz_temporary_access_expires_at";
    StorageKey["IMPERSONATED_USER"] = "adnz_impersonated_user";
})(StorageKey || (StorageKey = {}));
